import React, { useState, useEffect } from 'react';
import { PaintBrush } from '@phosphor-icons/react';
import { haptic } from '../utils/haptics';
import axiosInstance from '../api/api';

export function applyDashboardTheme(theme) {
  document.documentElement.classList.toggle('theme-bold', theme === 'bold');
}

export const DashboardThemeToggle = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem('dashboard_theme') || 'bold');

  useEffect(() => {
    applyDashboardTheme(theme);
  }, [theme]);

  // Sync from server so the preference follows the user across devices
  useEffect(() => {
    if (!localStorage.getItem('token')) return;
    axiosInstance.get('/users/theme')
      .then(({ data }) => {
        const serverTheme = data?.dashboard_theme;
        if (serverTheme && serverTheme !== localStorage.getItem('dashboard_theme')) {
          setTheme(serverTheme);
          localStorage.setItem('dashboard_theme', serverTheme);
        }
      })
      .catch(() => {});
  }, []);

  const pick = (t) => {
    haptic(8);
    setTheme(t);
    localStorage.setItem('dashboard_theme', t);
    if (localStorage.getItem('token')) {
      axiosInstance.put('/users/theme', { dashboard_theme: t }).catch(() => {});
    }
  };

  return (
    <div className="flex justify-end mb-3" data-testid="dashboard-theme-toggle">
      <div className="inline-flex items-center gap-1 bg-white dark:bg-neutral-800 border-2 border-[#0F172A] dark:border-neutral-600 rounded-lg p-1 shadow-[2px_2px_0px_#0F172A]">
        <PaintBrush size={14} weight="bold" className="text-[#5C5C5C] dark:text-neutral-400 ml-1" />
        {['soft', 'bold'].map((t) => (
          <button
            key={t}
            onClick={() => pick(t)}
            className={`px-3 py-1 text-[11px] font-black uppercase tracking-wider rounded transition-colors ${
              theme === t
                ? 'bg-[#0F172A] text-white'
                : 'text-[#5C5C5C] dark:text-neutral-400 hover:text-[#0F172A] dark:hover:text-white'
            }`}
            data-testid={`theme-${t}-btn`}
          >
            {t}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DashboardThemeToggle;
